import { AfterViewInit, Component, ElementRef, ViewChild } from "@angular/core";
import { TemaColores } from "../../providers/tema.service";

@Component({
    selector: 'app-theme-emitter',
    templateUrl: './theme-emitter.component.html',
    styles: [':host { display: none; }']
})
export class ThemeEmitterComponent implements AfterViewInit {
    private _primaryPalette: CSSStyleDeclaration;
    private _accentPalette: CSSStyleDeclaration;
    private _warnPalette: CSSStyleDeclaration;
    private _foregroundPalette: CSSStyleDeclaration;

    @ViewChild('primaryElement') private primaryElement: ElementRef;
    @ViewChild('accentElement') private accentElement: ElementRef;
    @ViewChild('warnElement') private warnElement: ElementRef;
    @ViewChild('foregroundElement') private foregroundElement: ElementRef;

    ngAfterViewInit() {
        this._primaryPalette = getComputedStyle(this.primaryElement.nativeElement);
        this._accentPalette = getComputedStyle(this.accentElement.nativeElement);
        this._warnPalette = getComputedStyle(this.warnElement.nativeElement);
        this._foregroundPalette = getComputedStyle(this.foregroundElement.nativeElement);
    }

    getColores() {
        return <TemaColores>{
            primary: this._primaryPalette,
            accent: this._accentPalette,
            warn: this._warnPalette,
            foreground: this._foregroundPalette
        }
    }
}